import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift, Sparkles, ArrowRight } from 'lucide-react';
const mainItems = [{
  title: 'Guía paso a paso + Videos tutoriales',
  desc: 'Una guía clara y acompañamiento visual para entender el proceso. Incluye video tutorial para tricotín manual sin máquina i-cord.',
  img: 'https://cdn.magicpatterns.com/uploads/pCSUj4DTLRMN6TvEL8bb5N/NUEVO_TRICOTIN.png'
}, {
  title: '+300 plantillas listas para usar',
  desc: 'Una colección más completa y variada para crear nombres, letras, flores, aros decorativos, souvenirs, fechas especiales y piezas personalizadas desde el principio.',
  img: 'https://cdn.magicpatterns.com/uploads/q65jBbtsuhnYkjtUc4nLTp/2B300_plantillas.png'
}, {
  title: 'Guía de emprendimiento',
  desc: 'Un recurso para mostrarte cómo llevar esta habilidad más allá del hobby y generar ingresos extra.',
  img: 'https://cdn.magicpatterns.com/uploads/kRZ6JYXf3JCouhrWqsinKK/GUIA_DE_EMPRENDIMIENTO.png'
}];
const bonusItems = [{
  title: 'Mini Guía de Llaveros Personalizados',
  desc: '+40 ideas simples, lindas y vendibles para empezar desde cero.',
  img: 'https://cdn.magicpatterns.com/uploads/2TyuLboRtG9jwaiqPZKDHW/GUIA_DE_LLAVEROS.png'
}, {
  title: 'Mini Guía de Lapiceras Decoradas',
  desc: '+30 ideas creativas, delicadas y útiles para sorprender.',
  img: 'https://cdn.magicpatterns.com/uploads/3U9pGLeX9v2vWZVkveeSV6/GUIA_DE_LAPICERAS.png'
}, {
  title: '+100 Ideas de Decoración con Tricotín',
  desc: 'Inspiración para decorar cuartos infantiles y espacios especiales.',
  img: 'https://cdn.magicpatterns.com/uploads/jKzcRUWErvXWKYfgRhkwtd/2B100_IDEAS_DECORACION.png'
}, {
  title: '+100 Ideas de Souvenirs para Eventos',
  desc: 'Ideas lindas, creativas y fáciles para bautismos, cumpleaños y más.',
  img: 'https://cdn.magicpatterns.com/uploads/vpVTKVa81v6f4Y54vyxgUm/2B100_IDEAS_SOUVENIRS.png'
}];
export function KitContents() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-[#FFF9F3]" data-id="element-103">
      <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12 px-2" data-id="element-104">
        <h2 className="text-2xl sm:text-4xl lg:text-5xl text-brand-text mb-4 sm:mb-6 font-bold leading-tight" data-id="element-105">
          Todo lo que incluye el Kit
        </h2>
        <p className="text-base sm:text-lg text-brand-text/80 leading-relaxed font-medium" data-id="element-106">
          Un kit completo para aprender desde cero, crear con más seguridad y
          empezar a transformar esta habilidad en algo hermoso y vendible.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12 sm:mb-16" data-id="element-107">
        {mainItems.map((item, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: i * 0.1
      }} className="bg-brand-card rounded-[2rem] overflow-hidden shadow-lg border border-brand-sand flex flex-col" data-id="element-108">
            <div className="relative aspect-[4/3] sm:aspect-[4/5] bg-brand-sand/40 p-4 sm:p-8 flex items-center justify-center" data-id="element-109">
              <img src={item.img} alt={item.title} className={`w-full h-full drop-shadow-xl rounded-xl sm:rounded-2xl object-contain`} data-id="element-110" />
            </div>

            <div className="p-6 sm:p-8 flex-1 flex flex-col" data-id="element-111">
              <h3 className="text-xl sm:text-2xl text-brand-text font-serif font-bold mb-2 sm:mb-4 leading-tight" data-id="element-112">
                {item.title}
              </h3>
              <p className="text-brand-text/70 font-normal leading-relaxed text-sm sm:text-base flex-1" data-id="element-113">
                {item.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      <div className="relative py-12 sm:py-16 border-t border-brand-warm" data-id="element-114">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-bg px-4 sm:px-6" data-id="element-115">
          <Gift className="w-10 h-10 sm:w-12 sm:h-12 text-brand-bonus" data-id="element-116" />
        </div>

        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12 px-2" data-id="element-117">
          <h3 className="text-2xl sm:text-4xl lg:text-5xl text-brand-text mb-4 font-bold leading-tight" data-id="element-118">
            Y además, hoy te llevás{' '}
            <span className="font-script text-brand-cta text-4xl sm:text-6xl lg:text-7xl block sm:inline mt-1 sm:mt-0" data-id="element-119">
              bonos
            </span>{' '}
            de regalo
          </h3>
          <p className="text-sm sm:text-base text-brand-text/80 leading-relaxed font-normal" data-id="element-120">
            Solo por hoy, además del kit completo, accedés a recursos extra
            pensados para darte más ideas, más variedad y más valor dentro de tu
            compra.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-121">
          {bonusItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.1
        }} className="bg-brand-card rounded-[1.5rem] sm:rounded-[2rem] overflow-hidden shadow-md border-2 border-brand-bonus/20 flex flex-col relative" data-id="element-122">
              <div className="relative aspect-[4/3] sm:aspect-[4/5] bg-brand-warm/20 p-4 sm:p-6 flex items-center justify-center" data-id="element-123">
                <img src={item.img} alt={item.title} className="w-full h-full drop-shadow-md rounded-xl object-contain" data-id="element-124" />
              </div>

              <div className="p-5 sm:p-6 flex-1 flex flex-col bg-gradient-to-b from-brand-bonus/5 to-transparent" data-id="element-125">
                <h4 className="text-lg sm:text-xl text-brand-text font-serif font-bold mb-2 leading-tight" data-id="element-126">
                  {item.title}
                </h4>
                <p className="text-brand-text/70 font-normal text-sm flex-1" data-id="element-127">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}